import { Box, styled } from '@mui/material';

export const TopNavBarContainer = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  padding: '12px 150px',
  display: 'grid',
  gridTemplateColumns: 'auto 1fr auto',
  boxSizing: 'border-box',

  '@media screen and (max-width: 1280px)': {
    padding: '12px 70px',
  },

  '@media screen and (max-width: 640px)': {
    gridTemplateColumns: 'none',
    gridTemplateRows: 'auto 1fr auto',
    padding: '26px 12px',
  },
}));

export const LogoContainer = styled(Box)(() => ({
  display: 'flex',
  margin: 'auto 0',

  '@media screen and (max-width: 640px)': {
    margin: 'auto',
  },

  zIndex: 1,
}));

export const ToggleButtonContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft: '48px',

  '@media screen and (max-width: 640px)': {
    marginLeft: 0,
    marginTop: '24px',
  },
}));
